(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PAD = function (n) {
      return n < 10 ? '0' + n : String(n);
    };

    function init(root) {
      if (!root || root.dataset.splitHeroReady === 'true') return;

      var track = root.querySelector('[data-split-hero-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;

      var prev = root.querySelector('[data-split-hero-prev]');
      var next = root.querySelector('[data-split-hero-next]');
      var current = root.querySelector('[data-split-hero-current]');
      var total = root.querySelector('[data-split-hero-total]');

      if (total) total.textContent = PAD(slides.length);

      function step() {
        var first = slides[0];
        return first ? first.getBoundingClientRect().width : track.clientWidth;
      }

      function activeIndex() {
        var s = step();
        if (!s) return 0;
        var i = Math.round(track.scrollLeft / s);
        return Math.max(0, Math.min(slides.length - 1, i));
      }

      function sync() {
        var i = activeIndex();
        if (current) current.textContent = PAD(i + 1);

        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      }

      function go(dir) {
        track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          sync();
        });
      });

      window.addEventListener('resize', sync);
      sync();

      root.dataset.splitHeroReady = 'true';
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll('[data-split-hero]');
      Array.prototype.forEach.call(nodes, init);
    }

    /* Reveal each homepage section as it enters the viewport. Works whether the
       page scrolls on the window or inside Dwell's .page-wrapper, because the
       observer watches viewport intersection either way. */
    function initReveals() {
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var sections = document.querySelectorAll('.content-for-layout > .shopify-section');
      if (sections.length < 2) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('av-revealed');
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.04 }
      );

      Array.prototype.forEach.call(sections, function (section, i) {
        // never hide the hero, and skip anything already marked
        if (i === 0 || section.classList.contains('av-reveal')) return;

        var items = section.querySelectorAll('.resource-list__item');
        if (items.length > 1) {
          section.classList.add('av-has-items');
          Array.prototype.forEach.call(items, function (item, n) {
            item.classList.add('av-item');
            item.style.setProperty('--av-i', String(Math.min(n, 8)));
          });
        }

        section.classList.add('av-reveal');
        io.observe(section);
      });
    }

    /* Slow vertical drift on the editorial image as it passes through the
       viewport. Reads the element's rect each frame so it works whether the
       page scrolls on the window or inside Dwell's .page-wrapper. */
    function initParallax() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var editorial = document.querySelector('[id*="media_with_content"]');
      if (editorial) {
        var im = editorial.querySelector('img');
        if (im) im.setAttribute('data-av-parallax', '');
      }

      var nodes = document.querySelectorAll('img[data-av-parallax]');
      if (!nodes.length) return;

      var ticking = false;

      function update() {
        ticking = false;
        var vh = window.innerHeight || 1;
        Array.prototype.forEach.call(nodes, function (n) {
          var r = n.getBoundingClientRect();
          if (r.bottom < -300 || r.top > vh + 300) return;
          var progress = (r.top + r.height / 2 - vh / 2) / vh;
          var clamped = Math.max(-1, Math.min(1, progress));
          n.style.setProperty('--av-shift', (clamped * -20).toFixed(2) + 'px');
        });
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      var wrap = document.querySelector('.page-wrapper');
      if (wrap) wrap.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    function boot() {
      initAll();
      initReveals();
      initParallax();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
      initReveals();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sun-motion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__avSunReady) return;
    window.__avSunReady = true;

    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Dwell scrolls an inner .page-wrapper on desktop but the document on
       mobile, so resolve whichever is actually scrolling right now. */
    function scroller() {
      var wrap = document.querySelector('.page-wrapper');
      if (wrap && wrap.scrollHeight > wrap.clientHeight + 10) return wrap;
      return document.scrollingElement || document.body;
    }

    function readProgress() {
      var el = scroller();
      var max = el.scrollHeight - el.clientHeight;
      if (max <= 0) return 0;
      var p = el.scrollTop / max;
      return p < 0 ? 0 : p > 1 ? 1 : p;
    }

    var ticking = false;

    function frame() {
      ticking = false;
      root.style.setProperty('--av-sun', readProgress().toFixed(4));
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }

    function bindScroll() {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      var wrap = document.querySelector('.page-wrapper');
      if (wrap) wrap.addEventListener('scroll', onScroll, { passive: true });
      frame();
    }

    /* Product page gallery, revealed in sequence. */
    function initMedia() {
      if (reduce.matches) return;
      if (!('IntersectionObserver' in window)) return;

      var gallery = document.querySelector(
        '.product-media-container, [class*="product-media-gallery"], media-gallery'
      );
      if (!gallery) return;

      var items = gallery.querySelectorAll(
        '.product-media, [class*="product-media--"], .media-gallery__item, li'
      );
      if (items.length < 2) return;

      Array.prototype.forEach.call(items, function (item, i) {
        item.classList.add('av-media-item');
        item.style.setProperty('--av-i', String(Math.min(i, 6)));
      });

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            gallery.classList.add('av-media-shown');
            io.disconnect();
          });
        },
        { threshold: 0.02 }
      );
      io.observe(gallery);

      /* Safety net: never leave the gallery hidden if the observer misses. */
      setTimeout(function () {
        gallery.classList.add('av-media-shown');
      }, 2500);
    }

    function boot() {
      if (!reduce.matches) {
        root.classList.add('av-sun-active');
        bindScroll();
      }
      initMedia();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function () {
      onScroll();
      initMedia();
    });

    if (reduce.addEventListener) {
      reduce.addEventListener('change', function () {
        root.classList.toggle('av-sun-active', !reduce.matches);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
